// src/services/ReportadasService.js
import axios from 'axios';
import { buildApiUrl } from '../config/api';

export const ReportadasService = {
    get: async ({ token, vid }) => {
        try {
            const response = await axios.get(buildApiUrl('/api/reportadas'), {
                headers: { Authorization: `Bearer ${token}` },
                params: { vid },
            });
            return response.data;
        } catch (error) {
            console.error('Error en ReportadasService.get:', error);
            throw error;
        }
    },
    save: async ({token, formData}) => {
        await axios.post(buildApiUrl('/api/reportadas'), formData, {
            headers: { Authorization: `Bearer ${token}` },
        });
    },
    disable: async ({token, formData}) => {
        await axios.put(buildApiUrl('/api/reportadas'), formData, {
            headers: { Authorization: `Bearer ${token}` },
        });
    }
};
